import { render, staticRenderFns } from "./AddItemModal.vue?vue&type=template&id=55d353e6&scoped=true"
import script from "./AddItemModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddItemModal.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AddItemModal.vue?vue&type=style&index=0&id=55d353e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55d353e6",
  null
  
)

export default component.exports